import { render, staticRenderFns } from "./AdvertModal.vue?vue&type=template&id=01112a99&scoped=true"
import script from "./AdvertModal.vue?vue&type=script&lang=js"
export * from "./AdvertModal.vue?vue&type=script&lang=js"
import style0 from "./AdvertModal.vue?vue&type=style&index=0&id=01112a99&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01112a99",
  null
  
)

export default component.exports